import { GenericBackendResponse } from '../genericBackendResponse';

export interface OnboardingStatusAnonymousData {
	totalEmployees: number;
	activeEmployees: number;
}

export type GetOnboardingStatusAnonymousResponse =
	GenericBackendResponse<OnboardingStatusAnonymousData>;

const getOnboardingStatusAnonymous = async (
	token: string
): Promise<GetOnboardingStatusAnonymousResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/companies/onboarding-status-anonymous`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	return response.json();
};

export default getOnboardingStatusAnonymous;
